import { render } from "./ClosetWardrobeView.vue?vue&type=template&id=c9b39c6c&ts=true"
import script from "./ClosetWardrobeView.vue?vue&type=script&lang=ts"
export * from "./ClosetWardrobeView.vue?vue&type=script&lang=ts"

import "./ClosetWardrobeView.vue?vue&type=style&index=0&id=c9b39c6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__